import React, { useRef, useEffect } from "react";
import techVideo from "./media/implant_v1.mp4"; // update path
import "./TechSection.css";

function TechSection() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.8; // slower playback
    }
  }, []);

  return (
    <section className="tech-section">
      {/* Left: looping video */}
      <div className="tech-video">
        <video
          ref={videoRef}
          src={techVideo}
          autoPlay
          loop
          muted
          playsInline
          className="video-element"
        />
      </div>

      {/* Right: text content */}
      <div className="tech-content">
        <h1>
          Excellence in <br />
          <span className="highlight">full-arch implant dentistry</span>
        </h1>
        <p>
        Dr. Parismita Das is a trusted dental surgeon in Guwahati, providing patients with advanced, long-lasting solutions for missing teeth. With a focus on precision and patient comfort, she uses modern implant technology and meticulously planned treatment protocols to restore the full function and natural aesthetics of your smile. Her approach combines expertise, accuracy, and compassionate care—delivering results that truly transform confidence and quality of life.
        </p>
      </div>
    </section>
  );
}

export default TechSection;
